import styled from "styled-components";

export const PageContent = styled.div`
  padding: ${({ theme }) => theme.space[4]};
  max-width: 960px;
  margin: 0 auto;
`;

export const PageHeader = styled.div`
  margin-bottom: ${({ theme }) => theme.space[5]};
`;

export const PageTitle = styled.h1`
  font-size: ${({ theme }) => theme.fonts.lg};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primary};
  margin: 0 0 ${({ theme }) => theme.space[1]} 0;
`;

export const PageSubtitle = styled.p`
  font-size: ${({ theme }) => theme.fonts.sm};
  color: ${({ theme }) => theme.colors.gray500};
  margin: 0;
`;

export const SearchActions = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.space[2]};
  margin-bottom: ${({ theme }) => theme.space[3]};
`;

export const SearchBar = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: ${({ theme }) => theme.space[3]};
  padding-left: 40px;
  background-color: ${({ theme }) => theme.colors.gray50};
  border: 1px solid ${({ theme }) => theme.colors.gray200};
  border-radius: ${({ theme }) => theme.radius.md};
  font-size: ${({ theme }) => theme.fonts.sm};
  color: ${({ theme }) => theme.colors.gray800};
  outline: none;
  transition: border-color ${({ theme }) => theme.transitions.fast};

  &::placeholder {
    color: ${({ theme }) => theme.colors.gray400};
    font-style: italic;
  }

  &:focus {
    border-color: ${({ theme }) => theme.colors.primary};
  }
`;

export const BtnLocation = styled.button`
  width: 42px;
  height: 42px;
  min-width: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.successLight};
  color: ${({ theme }) => theme.colors.white};
  border: none;
  border-radius: ${({ theme }) => theme.radius.md};
  cursor: pointer;
  transition: background-color ${({ theme }) => theme.transitions.fast};

  ${({ $active, theme }) =>
    $active &&
    `
    box-shadow: inset -2px 2px 4px rgba(0,0,0,0.15);
  `}

  &:hover {
    background-color: ${({ theme }) => theme.colors.successHover};
  }
`;

export const LocationBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => theme.space[3]};
  margin-bottom: ${({ theme }) => theme.space[3]};
  background-color: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: ${({ theme }) => theme.radius.md};
  font-size: ${({ theme }) => theme.fonts.sm};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.gray800};
  cursor: pointer;

  svg {
    flex-shrink: 0;
    margin-left: ${({ theme }) => theme.space[2]};
  }
`;

export const TimeFilters = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.space[2]};
  margin-bottom: ${({ theme }) => theme.space[3]};
  flex-wrap: wrap;
`;

export const TimeFilterChip = styled.button`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.space[1]};
  padding: ${({ theme }) => theme.space[2]} ${({ theme }) => theme.space[3]};
  background: ${({ $active, theme }) => $active ? theme.colors.primary : theme.colors.white};
  color: ${({ $active, theme }) => $active ? theme.colors.white : theme.colors.primary};
  border: 1.5px solid ${({ $active, theme }) => $active ? theme.colors.primary : theme.colors.gray200};
  border-radius: ${({ theme }) => theme.radius.full};
  font-size: ${({ theme }) => theme.fonts.xs};
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: all ${({ theme }) => theme.transitions.fast};

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
    background: ${({ $active, theme }) => $active ? theme.colors.primaryLight : theme.colors.primaryBg};
  }
`;

export const CardList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space[3]};

  @media (min-width: 769px) {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  }
`;
